<template>
    <div class="resource-box">
       <!-- 图片 -->
        <img v-if="resourceUrl[0].fileType===0" :src="Bus.imgPath(resourceUrl[0].fileCode)" onerror="this.src='/images/theme/newDark/default.png'"/>
        <!-- 视频 -->
        <video preload="none" id="videoDom" v-if="resourceUrl[0].fileType===1" :src="Bus.imgPath(resourceUrl[0].fileCode)" controls="controls">您的浏览器不支持 video 标签。</video>
        <img v-if="resourceUrl[0].fileType!=0&&resourceUrl[0].fileType!=1" :src="alarmImage(resourceUrl[0])" onerror="this.src='/images/theme/newDark/default.png'"/>
    </div>
</template>
<script>
import { Base,Bus,Cache } from '$utils'
export default {
    props:{
        // 该行数据
        resourceUrl:{
        type:Array,
        default:function(){
            return []
        }},
        // 告警详情
        taskAlarmInfo:{
        type:Object,
        default:function(){
            return {}
        }}
    },
    data(){
        return{
            Base,
            Bus,
            types:{
                image:'image',
                video:'video'
            }
        }
    },
    methods: {
       alarmImage(item) {
            const token = Cache.get('access_token')
            let url = '';
            switch(item.fileType){
                case 0: url=`/bas/safeEvent/picStreamInfo.json?resourceCode=${this.taskAlarmInfo.resourceCode}&ticket=${token}`;
                break;
                case 4: url=`/bas/safeEvent/picStreamInfo.json?alarmId=${this.taskAlarmInfo.alarmId}&alarmType=${this.taskAlarmInfo.alarmType}&deviceId=${this.taskAlarmInfo.alarmDevId}&picResourceType=3&ticket=${token}`;
                break;
                case 3: url = `/bas/safeEvent/picStreamInfo.json?alarmId=${this.taskAlarmInfo.alarmId}&alarmType=${this.taskAlarmInfo.alarmType}&picResourceType=4&ticket=${token}`;
                break;
                default:url = `/bas/safeEvent/picStreamInfo.json?picResourceType=${item.fileType}&alarmType=${this.taskAlarmInfo.alarmType}&alarmId=${this.taskAlarmInfo.alarmId}&ticket=${token}&resourceCode=${this.taskAlarmInfo.resourceCode}`;
            }
            console.log(url);
                return url
        },
        stopVideo(){
            if(document.getElementById('videoDom')){
                document.getElementById('videoDom').pause();
            }
        }
    }
}
</script>
<style>
    .resource-box{
        width: 500px;
    }
    .resource-box img,.resource-box video{
        width: 100%;
        max-height: 600px;
    }
</style>

